/* eslint-disable no-unused-expressions */
/* eslint-disable mdx/no-unused-expressions */
import { MDXProvider } from '@mdx-js/react'
import {
  Col,
  Container,
  Row,
  Tooltip,
  Button,
  Icon,
  AccordionRow,
} from '@paypalcorp/pp-react'
import { graphql } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import moment from 'moment'
import React, { useEffect, useLayoutEffect, useState, useCallback } from 'react'
import {
  CodeBlock,
  CodeBlockWrapper,
  RunInPostman,
  YouTubeColumnLayout,
  YoutubeVideo,
  Pills,
} from '../components/layout'
import BreadCrumbs from '../components/layout/BreadCrumbs'
import CountryDropdown from '../components/layout/CountryDropdown/countryDropdown'
import Table from '../components/icons/Table'
import Layout from './layout'

import { Tab, Tabs } from '../utils/Tabs'
import ExperimentHoc from '../utils/ExperimentHoc'
import ContentAccordion from '../utils/ContentAccordion'
import { ContentTabs, ContentTab } from '../utils/ContentTabs'
import MarkdownLink from '../utils/Links'
import ImageLink from '../utils/Images'
/*
  Base Template for each markdown pages.
*/
import '../css/ppvx.css'
import '../css/fonts-and-normalize.css'
import '../css/docs.css'
import './index.css'

import CheckoutGraphic from '../components/icons/CheckoutGraphic'
import { useApplicationContext } from '../provider'
import { Spacer } from '../components/layout/Spacer'
import { PaymentsDropdown } from '../components/layout/PaymentsDropdown'

const displayCountryDropdown = '/pay-later/'

const vaultDropdownRoutes = [
  '/beta/vault/during-purchase/js-sdk/',
  '/beta/vault/during-purchase/orders-api/',
  '/beta/vault/purchase-later/',
]
const displayPaymentsDropdown = new RegExp(vaultDropdownRoutes.join('|'), 'gi')

const components = {
  CodeBlock,
  Tab,
  Tabs,
  ContentTab,
  ContentTabs,
  CodeBlockWrapper,
  Col,
  ExperimentHoc,
  Row,
  Container,
  Table,
  CheckoutGraphic,
  Tooltip,
  img: (props) => <ImageLink {...props} />,
  a: (props) => <MarkdownLink {...props} />,
  Spacer,
  RunInPostman,
  YouTubeColumnLayout,
  YoutubeVideo,
  Button,
  Icon,
  Pills,
  ContentAccordion,
  AccordionRow,
}

const addAnchorsToTable = (tableRow) => {
  const list = Array.from(document.getElementsByTagName(tableRow))
  list.forEach((tr) => {
    let _anchorLink = tr.textContent.toLowerCase().trim().replace(/\s+/g, '-')
    tr.id = _anchorLink

    if (tr.textContent && tr.id) {
      if (
        tr.firstElementChild &&
        tr.firstElementChild.nodeName.toLowerCase() === `td`
      ) {
        let trChild = tr.firstElementChild
        if (trChild.childNodes.length) {
          tr.classList += `dx-anchor`

          let anchorLink = document.createElement(`a`)
          anchorLink.href = `#${_anchorLink}`
          anchorLink.setAttribute(`aria-hidden`, `true`)
          anchorLink.setAttribute(`pa-marked`, `1`)

          trChild.insertBefore(anchorLink, trChild.childNodes[0])
        }
      }
    }
  })
}

const emptyHeaders = (tableItem) => {
  let hideCount = 0
  let childCount = 0
  let tableHead = tableItem.firstElementChild

  if (tableHead && tableHead.nodeName.toLowerCase() === 'thead') {
    let tableRow = tableHead.firstElementChild
    if (tableRow && tableRow.nodeName.toLowerCase() === 'tr') {
      let thItem = tableRow.firstElementChild
      while (thItem && thItem.nodeName.toLowerCase() === 'th') {
        childCount++
        if (!thItem.textContent || thItem.textContent.trim() === '') {
          hideCount++
        }
        thItem = thItem.nextElementSibling
      }
    }
  } else if (tableHead && tableHead.nodeName.toLowerCase() === 'tbody') {
    let tableRow = tableHead.firstElementChild
    if (tableRow && tableRow.nodeName.toLowerCase() === 'tr') {
      let thItem = tableRow.firstElementChild
      while (thItem && thItem.nodeName.toLowerCase() === 'th') {
        childCount++
        if (!thItem.textContent || thItem.textContent.trim() === '') {
          hideCount++
        }
        thItem = thItem.nextElementSibling
      }
    }
  } else if (tableHead && tableHead.nodeName.toLowerCase() === 'colgroup') {
    let tableActualHead = tableHead.nextElementSibling
    if (tableActualHead && tableActualHead.nodeName.toLowerCase() === 'thead') {
      let tableRow = tableActualHead.firstElementChild
      if (tableRow && tableRow.nodeName.toLowerCase() === 'tr') {
        let thItem = tableRow.firstElementChild
        while (thItem && thItem.nodeName.toLowerCase() === 'th') {
          childCount++
          if (!thItem.textContent || thItem.textContent.trim() === '') {
            hideCount++
          }
          thItem = thItem.nextElementSibling
        }
      }
    }
  } else {
    return true
  }

  if (hideCount === childCount && hideCount > 0) {
    return true
  }

  return false
}

const addTableClasses = () => {
  const list = Array.from(document.getElementsByTagName('table'))

  list.forEach((tableItem) => {
    tableItem.classList.add('ppvx_table')
    tableItem.classList.add('ppvx_table-responsive-sm')
  })
}

const removeTableHeadingIfEmpty = () => {
  const list = Array.from(document.getElementsByTagName('table'))

  list.forEach((tableItem) => {
    if (emptyHeaders(tableItem)) {
      tableItem.classList.add('dx-table-lite')
    }
  })
}

export default function Home(props) {
  const { setRightNav } = useApplicationContext()
  const [rightNavs, setRightNavs] = useState([])

  const addAnchors = (heading, rightNavHrefs = []) => {
    const list = Array.from(document.getElementsByTagName(heading))
    list.forEach((h) => {
      let anchorLink = h.textContent.toLowerCase().trim().replace(/\s+/g, '-')
      let newAnchor = 'link-'
      newAnchor += anchorLink.replace(/[^A-Za-z]+/g, '')

      h.id = anchorLink
      if (h.textContent) {
        h.classList += 'dx-anchor'
        h.innerHTML = `<span class="headingAnchorLinks" id="${newAnchor}"></span><a class="dx-anchor__icon" href="#${newAnchor}" aria-hidden="true" pa-marked="1" tabIndex="-1"></a> ${h.textContent}`
        heading === 'h2' &&
          rightNavHrefs.push({ content: h.textContent, id: newAnchor, a: 'a' })
      }
      document.getElementById(h.id).addEventListener('click', function () {
        const rightNavs = document.querySelectorAll('.rightNav-anchor')
        Array.from(rightNavs).forEach((rightNav) => {
          const href = rightNav.getAttribute('href').substring(1)
          if (href === newAnchor && !rightNav.classList.contains(href)) {
            setRightNav(href)
          }
        })
      })
    })
    return rightNavHrefs
  }
  const removeClassOrNodeFromDom = useCallback(
    () =>
      window.document
        .querySelector('.sidebar-title')
        ?.classList.remove('.dx-anchor'),
    [],
  )

  useEffect(() => {
    removeClassOrNodeFromDom()
    return () => {}
  }, [removeClassOrNodeFromDom])

  useEffect(() => {
    const sidebarTitle = window.document
      .querySelector('.sidebar-title a')
      ?.remove()

    return sidebarTitle
  }, [])

  // picking all the h2 tags and adding an anchor to it.
  useLayoutEffect(() => {
    const anchorHeadings = ['h1', 'h2', 'h3', 'h4', 'h5']
    anchorHeadings.forEach((heading) => {
      const rightNavHrefs = addAnchors(heading)
      // eslint-disable-next-line mdx/no-unused-expressions
      rightNavHrefs.length && setRightNavs(rightNavHrefs)
    })

    const tableItems = ['tr']
    tableItems.forEach((tableRow) => {
      addAnchorsToTable(tableRow)
    })

    removeTableHeadingIfEmpty()
    addTableClasses()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const {
    mdx: { frontmatter, body },
  } = props.data
  const filePath = props.data.mdx.fileAbsolutePath

  const isPayLater =
    filePath && filePath.includes(displayCountryDropdown) ? true : false
  const isPayWith =
    filePath && displayPaymentsDropdown.test(filePath) ? true : false

  /**
   **NOTE: Don't remove this, it is just a tweak
   **to make the PaymentsDropdown work
   **/
  displayPaymentsDropdown.test(filePath)

  let countrySelector = isPayLater ? <CountryDropdown /> : null
  let paymentSelector = isPayWith ? <PaymentsDropdown /> : null
  let subtitle = null
  if (
    frontmatter &&
    frontmatter.subtitle &&
    frontmatter.subtitle.trim() !== ``
  ) {
    subtitle = (
      <p className="dx-content-subtitle">
        {frontmatter && frontmatter.subtitle}
      </p>
    )
  }

  useEffect(() => {
    // Fire impression event to amplitude
    // camelCase is not allowed in FPTI Tags so using snake_case
    if (frontmatter.amplitude) {
      const [product, event_name, event_prop, event_value] =
        frontmatter.amplitude.split(',')
      const data = {
        product,
        event_name,
      }
      if (event_prop && event_value) {
        data.event_props = event_prop
        data[event_prop] = event_value
      }
      // eslint-disable-next-line mdx/no-unused-expressions
      // eslint-disable-next-line no-unused-expressions
      window?.PAYPAL?.analytics?.instance?.recordImpression({
        data,
      })
      if (window.fpti) {
        //clear the fpti data added above
        window.fpti.product = null
        window.fpti.event_name = null
        window.fpti.event_props = null
        window.fpti[event_prop] = null
      }
    }
  }, [frontmatter])

  return (
    <Layout
      rightNav={rightNavs}
      leftNavBar={true}
      layout="dx-docs"
      activeNavLocal
      location={props.location}
      title={frontmatter.title}
      description={frontmatter.description}
      keywords={frontmatter.keywords}
      contentType={frontmatter.contentType}
      productStatus={frontmatter.productStatus}
      apiVersion={frontmatter.apiVersion}
      sdkVersion={frontmatter.sdkVersion}
      sIntegration={frontmatter.sIntegration}
      aIntegration={frontmatter.aIntegration}
      amplitude={frontmatter.amplitude}
    >
      <div id="hashLinkContainer" />
      <main className="content dx-content">
        <BreadCrumbs {...props} />
        <h1 className="dx-content-title ">
          {frontmatter && frontmatter.title}
        </h1>
        {subtitle}
        <p className="dx-status-wrapper">
          {frontmatter && frontmatter.contentType && (
            <span className="dx-content-type">{frontmatter.contentType}</span>
          )}
          {frontmatter && frontmatter.productStatus && (
            <span className="dx-product-status">
              {frontmatter.productStatus}
            </span>
          )}
          {frontmatter && frontmatter.sIntegration && (
            <span className="dx-sIntegration">{frontmatter.sIntegration}</span>
          )}
          {frontmatter && frontmatter.aIntegration && (
            <span className="dx-aIntegration">{frontmatter.aIntegration}</span>
          )}
          {frontmatter && frontmatter.date && (
            <span className="dx-product-lastUpdated">
              Last updated:{' '}
              {moment(frontmatter.date).format('MMMM Do YYYY, @ h:mm:ss a')}
            </span>
          )}
        </p>
        {countrySelector}
        {paymentSelector}
        <br />
        <MDXProvider components={components}>
          <MDXRenderer>{body}</MDXRenderer>
        </MDXProvider>
        <div id="docsFeedback_bottomOfSection" />
      </main>
    </Layout>
  )
}

// query to get html and frontmatter
export const pageQuery = graphql`
  query ($fileAbsolutePath: String) {
    mdx(fileAbsolutePath: { eq: $fileAbsolutePath }) {
      body
      fileAbsolutePath
      frontmatter {
        title
        description
        subtitle
        keywords
        contentType
        productStatus
        apiVersion
        sdkVersion
        date
        sIntegration
        aIntegration
        amplitude
      }
    }
  }
`
